import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
export function InlineCTA() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-white py-6 md:py-8 px-6" data-id="element-151">
      <div className="max-w-3xl mx-auto" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center bg-gradient-to-br from-rose/10 to-gold/10 rounded-3xl p-6 md:p-8 border border-gold/20" data-id="element-153">
          <div className="flex flex-col items-center gap-2 mb-5" data-id="element-154">
            <div className="flex items-center gap-3" data-id="element-155">
              <span className="font-serif text-2xl text-brown/40 line-through" data-id="element-156">
                $27
              </span>
              <span className="font-sans text-base text-brown/70" data-id="element-157">USD</span>
            </div>
            <p className="font-sans text-base text-brown/80 font-medium" data-id="element-158">
              Hoy solo
            </p>
            <div className="flex items-baseline gap-2" data-id="element-159">
              <span className="font-serif text-4xl md:text-5xl font-bold text-rose whitespace-nowrap" data-id="element-160">
                $14.00
              </span>
              <span className="font-sans text-lg text-brown/70 font-medium" data-id="element-161">
                USD
              </span>
            </div>
          </div>
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => {
          trackAddToCart();
          window.open('https://www.inerciacero.com/cart/42837827551335:1', '_blank');
        }} className="bg-rose text-white font-sans font-semibold text-base md:text-lg px-8 md:px-12 py-4 md:py-5 rounded-full shadow-lg hover:bg-rose/90 transition-colors cursor-pointer" data-id="element-162">
            Quiero Sanar Mi Linaje y Recibir a Mi Hijo
          </motion.button>
          <p className="font-sans text-xs text-brown/60 mt-3" data-id="element-163">
            🔐 Acceso inmediato · Garantía de 30 días
          </p>
        </motion.div>
      </div>
    </section>;
}